import { convertCartItemToGAItem, getTripleID } from "./common"
export const trackViewItem = item => {
  if (window?.dataLayer) {
    item.count = item.count || 1
    window.dataLayer.push({
      event: "view_item",
      ecommerce: {
        currency: "HKD",
        value: (item?.promotionWareVO?.unitProPrice || item.warePrice) / 100,
        items: [convertCartItemToGAItem(item)]
      }
    })
  }
}
export const trackProductInteraction = item => {
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "product_interaction",
      interaction_type: "item image change",
      item_id: String(item.sku),
      item_name: item.wareName,
      item_category: "Product Detail",
      ...getTripleID(item)
    })
  }
}
